import { styled } from '@clickcease/cc-client-components-lib'

export const MccFormContainer = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const MccMiddleTextMargins = styled('div', {
  marginTop: '$2',
  marginBottom: '$6',
})
